var map = {
	"./ConfirmRegistration.vue": [
		"a263",
		"lazy-view-ConfirmRegistration-vue"
	],
	"./ForgotPassword.vue": [
		"f243",
		"lazy-view-ForgotPassword-vue"
	],
	"./Login.vue": [
		"a55b",
		"lazy-view-Login-vue"
	],
	"./Logout.vue": [
		"c100",
		"lazy-view-Logout-vue"
	],
	"./Register.vue": [
		"73cf",
		"chunk-686a929e",
		"lazy-view-Register-vue"
	],
	"./ResetPassword.vue": [
		"0813",
		"lazy-view-ResetPassword-vue"
	],
	"./ThankYou.vue": [
		"2368",
		"lazy-view-ThankYou-vue"
	],
	"./Wrapper.vue": [
		"ae0b",
		"lazy-view-Wrapper-vue"
	],
	"./admin/Campaign.vue": [
		"b453"
	],
	"./admin/Dashboard.vue": [
		"0a6e",
		"lazy-view-admin-Dashboard-vue"
	],
	"./admin/News.vue": [
		"e275"
	],
	"./admin/Product.vue": [
		"6e0a"
	],
	"./admin/Purchase.vue": [
		"cfe1"
	],
	"./admin/Reward.vue": [
		"553f"
	],
	"./admin/Sale.vue": [
		"4928"
	],
	"./admin/User.vue": [
		"de51"
	],
	"./errors/403.vue": [
		"cd10",
		"lazy-view-403-vue"
	],
	"./errors/404.vue": [
		"4b62",
		"lazy-view-404-vue"
	],
	"./sales/Dashboard.vue": [
		"9837",
		"lazy-view-sales-Dashboard-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;